import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

export const fetchStatus = () => api.get("/status").then((r) => r.data);
export const fetchSettings = () => api.get("/settings").then((r) => r.data);
export const saveSettings = (payload) => api.put("/settings", payload).then((r) => r.data);
export const testRegistrar = (registrar) =>
  api.post(`/settings/test/${registrar}`).then((r) => r.data);
export const fetchBranding = () => api.get("/branding").then((r) => r.data);

export const fetchListing = (slug) => api.get(`/listings/${slug}`).then((r) => r.data);
export const fetchShareDiscount = (slug) =>
  api.get(`/listings/${slug}/share-discount/eligible`).then((r) => r.data);
export const claimShareDiscount = (slug, payload) =>
  api.post(`/listings/${slug}/share-discount`, payload).then((r) => r.data);
export const validateDiscount = (code, slug) =>
  api.get("/discounts/validate", { params: { code, slug } }).then((r) => r.data);
export const submitOffer = (slug, payload) =>
  api.post(`/listings/${slug}/offer`, payload).then((r) => r.data);
export const trackEvent = (slug, payload) =>
  api.post(`/listings/${slug}/track`, payload).then((r) => r.data).catch(() => null);
export const fetchListings = () => api.get("/listings").then((r) => r.data);
export const fetchOffers = () => api.get("/offers").then((r) => r.data);
export const fetchAnalytics = (slug) =>
  api.get(`/listings/${slug}/analytics`).then((r) => r.data);
export const createCheckout = (slug, payload) =>
  api.post(`/listings/${slug}/checkout`, payload).then((r) => r.data);
export const fetchPaymentStatus = (sessionId) =>
  api.get(`/payments/status/${sessionId}`).then((r) => r.data);
export const fetchActivity = (slug) =>
  api.get(`/listings/${slug}/activity`).then((r) => r.data);
export const setupForward = (slug) =>
  api.post(`/listings/${slug}/setup-forward`).then((r) => r.data);
export const fetchAffiliateLinks = (category) =>
  api.get("/affiliate-links" + (category ? `?category=${encodeURIComponent(category)}` : "")).then((r) => r.data);
export const createAffiliateLink = (payload) =>
  api.post("/affiliate-links", payload).then((r) => r.data);
export const updateAffiliateLink = (id, payload) =>
  api.patch(`/affiliate-links/${id}`, payload).then((r) => r.data);
export const deleteAffiliateLink = (id) =>
  api.delete(`/affiliate-links/${id}`).then((r) => r.data);
export const fetchAffiliateCategories = () =>
  api.get("/affiliate-categories").then((r) => r.data);
export const fetchPublicAffiliateLander = (slug) =>
  api.get(`/affiliate-links/public/${slug}`).then((r) => r.data);
export const clickAffiliateLink = (slug) =>
  api.post(`/affiliate-links/click/${slug}`).then((r) => r.data);
export const fetchAuthAttempts = (limit = 100) =>
  api.get("/auth/attempts", { params: { limit } }).then((r) => r.data);
export const blockIp = (ip, hours = 24) =>
  api.post("/auth/block-ip", { ip, hours }).then((r) => r.data);
export const unblockIp = (ip) =>
  api.post("/auth/unblock-ip", { ip }).then((r) => r.data);
export const aiDiscoverDomains = (payload) =>
  api.post("/ai/discover", payload).then((r) => r.data);
export const aiRankDrops = (payload) =>
  api.post("/ai/rank-drops", payload).then((r) => r.data);
export const aiHistory = (params) =>
  api.get("/ai/history", { params }).then((r) => r.data);
export const aiHistoryDetail = (id) =>
  api.get(`/ai/history/${id}`).then((r) => r.data);
export const aiDailyPicksRunNow = () =>
  api.post("/ai/daily-picks/run").then((r) => r.data);
export const submitLead = (payload) =>
  api.post("/leads", payload).then((r) => r.data);
export const fetchComps = (tld, limit = 8) =>
  api.get("/comps", { params: { tld, limit } }).then((r) => r.data);
export const fetchLatestSold = () =>
  api.get("/listings/latest-sold").then((r) => r.data);
export const searchListings = (q, limit = 30) =>
  api.get("/listings/search", { params: { q: q || "", limit } }).then((r) => r.data);
export const fetchSimilarListings = (slug, limit = 3) =>
  api.get(`/listings/${slug}/similar`, { params: { limit } }).then((r) => r.data);
export const uploadAvatar = (file) => {
  const fd = new FormData();
  fd.append("file", file);
  return api.post("/upload/avatar", fd, {
    headers: { "Content-Type": "multipart/form-data" },
  }).then((r) => r.data);
};
export const bulkSnipesFromPortfolio = (payload) =>
  api.post("/snipes/bulk-from-portfolio", payload).then((r) => r.data);
export const createSnipeFromWhois = (payload) =>
  api.post("/snipes/from-portfolio", payload).then((r) => r.data);
export const fetchPortfolio = () => api.get("/portfolio").then((r) => r.data);
export const listForSale = (payload) =>
  api.post("/portfolio/list", payload).then((r) => r.data);
export const fetchStats = () => api.get("/stats").then((r) => r.data);
export const fetchLinkedProjects = (listingSlug) =>
  api.get(`/listings/${listingSlug}/linked-projects`).then((r) => r.data);

export const fetchMarketplaceStats = () => api.get("/marketplace/stats").then((r) => r.data);

// Projects (blog)
export const fetchProjects = (status) =>
  api.get("/projects", { params: status ? { status } : {} }).then((r) => r.data);
export const fetchProject = (slug) => api.get(`/projects/${slug}`).then((r) => r.data);
export const fetchAdminProjects = () => api.get("/projects/admin/all").then((r) => r.data);
export const trackProjectView = (slug, payload) =>
  api.post(`/projects/${slug}/track`, payload).then((r) => r.data).catch(() => null);
export const fetchProjectStats = (slug) =>
  api.get(`/projects/${slug}/stats`).then((r) => r.data);
export const createProject = (payload) => api.post("/projects", payload).then((r) => r.data);
export const updateProject = (id, payload) =>
  api.patch(`/projects/${id}`, payload).then((r) => r.data);
export const deleteProject = (id) => api.delete(`/projects/${id}`).then((r) => r.data);
export const fetchSnipes = () => api.get("/snipes").then((r) => r.data);
export const fetchTldRouting = () => api.get("/registrars/tld-routing").then((r) => r.data);
export const registerNow = (payload) => api.post("/register-now", payload).then((r) => r.data);
export const armSnipe = (payload) => api.post("/snipes/arm", payload).then((r) => r.data);
export const fetchLogs = (limit = 60) =>
  api.get(`/logs?limit=${limit}`).then((r) => r.data);
export const createSnipe = (payload) =>
  api.post("/snipes", payload).then((r) => r.data);
export const deleteSnipe = (id) => api.delete(`/snipes/${id}`).then((r) => r.data);
export const cancelSnipe = (id) =>
  api.post(`/snipes/${id}/cancel`).then((r) => r.data);
export const fireSnipe = (id) =>
  api.post(`/snipes/${id}/fire`).then((r) => r.data);
export const retrySnipe = (id) =>
  api.post(`/snipes/${id}/retry`).then((r) => r.data);
export const preflightSnipe = (id) =>
  api.post(`/snipes/${id}/preflight`).then((r) => r.data);
export const autofixPreflight = (id) =>
  api.post(`/snipes/${id}/preflight/autofix`).then((r) => r.data);
export const checkAvailability = (domain) =>
  api.post("/domains/check", { domain }).then((r) => r.data);
export const clearLogs = () => api.delete("/logs").then((r) => r.data);
export const fetchAnalyticsOverview = (range = "30d") =>
  api.get(`/analytics/overview?range=${encodeURIComponent(range)}`).then((r) => r.data);
export const fetchCheckoutPlan = (slug) =>
  api.get(`/listings/${slug}/checkout-plan`).then((r) => r.data);
export const createBunqPayment = (slug, payload) =>
  api.post(`/listings/${slug}/bunq/create`, payload).then((r) => r.data);
export const fetchBunqStatus = (tabId) =>
  api.get(`/payments/bunq/status/${tabId}`).then((r) => r.data);
export const createEmbeddedCheckout = (slug, payload) =>
  api.post(`/listings/${slug}/checkout-embedded`, payload).then((r) => r.data);
export const fetchEmbeddedStatus = (sessionId) =>
  api.get(`/payments/embedded/status/${sessionId}`).then((r) => r.data);
export const fetchIntentStatus = (paymentIntentId) =>
  api.get(`/payments/intent/status/${paymentIntentId}`).then((r) => r.data);
export const createSnipesBulk = (snipes) =>
  api.post("/snipes/bulk", { snipes }).then((r) => r.data);
export const fetchDropsFeed = (params) =>
  api.get(`/drops/feed`, { params }).then((r) => r.data);

// Cold mailer
export const mailListTemplates = () => api.get("/mail/templates").then((r) => r.data);
export const mailCreateTemplate = (p) => api.post("/mail/templates", p).then((r) => r.data);
export const mailDeleteTemplate = (id) => api.delete(`/mail/templates/${id}`).then((r) => r.data);
export const mailListLists = () => api.get("/mail/lists").then((r) => r.data);
export const mailCreateList = (p) => api.post("/mail/lists", p).then((r) => r.data);
export const mailImportContacts = (lid, text) => api.post(`/mail/lists/${lid}/import`, { text }).then((r) => r.data);
export const mailListContacts = (lid) => api.get(`/mail/lists/${lid}/contacts`).then((r) => r.data);
export const mailListCampaigns = () => api.get("/mail/campaigns").then((r) => r.data);
export const mailCreateCampaign = (p) => api.post("/mail/campaigns", p).then((r) => r.data);
export const mailStartCampaign = (cid) => api.post(`/mail/campaigns/${cid}/send`).then((r) => r.data);
export const mailPauseCampaign = (cid) => api.post(`/mail/campaigns/${cid}/pause`).then((r) => r.data);
export const mailPreview = (p) => api.post("/mail/preview", p).then((r) => r.data);
